import React from 'react';
import cn from 'classnames';
import PageSizeButton from '../../../../../components/PageSizeButton/PageSizeButton';
import DspxPagination from '../../../../../components/DspxPagination/DspxPagination';
import styles from './PaginationBlock.module.scss';

const PaginationBlock = ({
  rootClassName,
  currentPageNumber,
  onPageChange,
  onPageSizeChange,
  showQuickJumper,
  pageSize,
  total,
}) => {
  return (
    <div className={cn(styles.root, rootClassName)}>
      <PageSizeButton
        pageSize={pageSize}
        setPageSize={onPageSizeChange}
        className={styles.pageSizeBtnWrap}
        buttonClassName={styles.pageSizeBtn}
      />
      <DspxPagination
        current={currentPageNumber + 1}
        total={total}
        pageSize={pageSize}
        showQuickJumper={showQuickJumper}
        quickJumperToStart
        onChange={onPageChange}
        hideOnSinglePage
      />
    </div>
  );
};

export default PaginationBlock;
